module.exports = __webpack_public_path__ + "assets/96c38f146a3499921d3db01136b804cc.svg";